var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined'
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined'
	&& typeof boostPFSThemeConfig != 'undefined'
	&& boostPFSConfig.general.isInitFilter === true) {
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
  if (window.matchMedia("(min-width: 990px)").matches) {
	  boostPFS.initSearchBox();
  }
	false && boostPFS.initAnalytics();
});